// extracted by mini-css-extract-plugin
var _1 = "jxxIxJIM__NV_mLSe621";
var _2 = "x6_IRZnsNmDVfDIm49p4";
var _3 = "VPsVCqxKtoKRd0fGTUh5";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "FjPO_iIQbKurcXJt_sO6";
var _13 = "1200px";
var _14 = "992px";
var _15 = "1366px";
var _16 = "768px";
var _17 = "1475px";
var _18 = "576px";
var _19 = "1600px";
var _1a = "320px";
var _1b = "2500px";
var _1c = "t48XcAVnyejUdqWl6PQ9";
export { _1 as "action", _2 as "active-media-preview", _3 as "base-link", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "reset-button", _13 as "screenlg", _14 as "screenmd", _15 as "screenml", _16 as "screensm", _17 as "screenxlg", _18 as "screenxs", _19 as "screenxxlg", _1a as "screenxxs", _1b as "screenxxxlg", _1c as "single-page-responsive-font-size" }
export default { "action": _1, "active-media-preview": _2, "base-link": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "reset-button": _12, "screenlg": _13, "screenmd": _14, "screenml": _15, "screensm": _16, "screenxlg": _17, "screenxs": _18, "screenxxlg": _19, "screenxxs": _1a, "screenxxxlg": _1b, "single-page-responsive-font-size": _1c }
